export enum Breakpoints {
    mobile = '1000px',
    mobileSmall = '500px',
    falseBottom = '690px',
    font = '1180px',
}
